const baseUrl = "/"

export default baseUrl